export default "__VITE_ASSET__hDRIuUUs__"